import { useEffect, useRef } from 'react';
export const useCancelQuery = reportPayload => {
  // keep track of the report payload
  const reportPayloadRef = useRef(reportPayload);

  // Keep track of the current abort controller
  const abortControllerRef = useRef(reportPayload ? new AbortController() : null);

  // Create a new abort controller when the payload changes
  useEffect(() => {
    if (reportPayloadRef.current === reportPayload) {
      return;
    }
    reportPayloadRef.current = reportPayload;

    // in the case we have a new reportPayload
    // Abort the previous request and create a new controller
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();
  }, [reportPayload]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);
  return abortControllerRef;
};